import type { IconProps } from './IconProps';

export const TikTokIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      d="M13.8094 6.80887C12.6229 6.80887 11.5245 6.43189 10.6275 5.79124V10.4483C10.6275 12.778 8.73797 14.6666 6.40715 14.6666C5.53749 14.6666 4.72917 14.4038 4.0577 13.9531C2.92947 13.196 2.18665 11.9086 2.18665 10.4483C2.18665 8.11877 4.07622 6.2302 6.40722 6.23025C6.60093 6.23016 6.79441 6.24331 6.98631 6.26953V6.78661L6.9862 8.60258C6.80149 8.544 6.60459 8.51221 6.40029 8.51221C5.334 8.51221 4.46977 9.37615 4.46977 10.4417C4.46977 11.1951 4.90177 11.8475 5.53172 12.1653C5.79292 12.297 6.08792 12.3712 6.40031 12.3712C7.4644 12.3712 8.32715 11.5108 8.33082 10.4483V1.33325H10.6275V1.62678C10.6356 1.71453 10.6472 1.80195 10.6624 1.8888C10.8218 2.7975 11.3655 3.57388 12.12 4.04449C12.6267 4.36061 13.2122 4.52772 13.8094 4.52682L13.8094 6.80887Z"
      fill="currentColor"
    />
  </svg>
);
